import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import { Currency } from '@/shared/api';
import { EQueryKeys } from '@/shared/config';

import { currenciesQuery } from '../api';
import { useCurrenciesStore } from '../model';

export const useCurrenciesController = () => {
  const setCurrencies = useCurrenciesStore((state) => state.setCurrencies);
  const { data: currencies, isPending } = useQuery({
    queryKey: [EQueryKeys.CurrenciesQueryKey],
    queryFn: async () => await currenciesQuery(),
    //enabled: Boolean(localStorage.getItem('@accessToken')),
  });

  useEffect(() => {
    if (!currencies?.length) return;
    setCurrencies(currencies as Currency[]);
  }, [currencies]);
  return isPending;
};
